import React from 'react';

export default function KpiTaEvolutionStatic() {
  const totalCreated = 693;
  const withTagTcByIa = 171;
  const withoutTagTcByIa = totalCreated - withTagTcByIa;
  const withTagPercent = ((withTagTcByIa / totalCreated) * 100).toFixed(1);
  const withoutTagPercent = ((withoutTagTcByIa / totalCreated) * 100).toFixed(1);

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-bold mb-4">Evolution des tests automatisés</h2>

      <div className="space-y-4">
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <h3 className="text-sm font-semibold text-gray-700 mb-3">Test Cases Créés en 2025</h3>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <div className="bg-white rounded-lg p-4 border border-gray-200">
              <div className="text-sm font-semibold text-gray-700">Total créés</div>
              <div className="text-4xl font-bold text-gray-900 mt-2">{totalCreated}</div>
            </div>

            <div className="bg-white rounded-lg p-4 border-l-4 border-green-500 border-t border-r border-b border-gray-200">
              <div className="text-sm font-semibold text-gray-700">Avec tag TC_by_IA</div>
              <div className="text-4xl font-bold text-green-700 mt-2">{withTagTcByIa}</div>
              <div className="text-sm text-gray-600 mt-1">{withTagPercent}% du total</div>
            </div>

            <div className="bg-white rounded-lg p-4 border-l-4 border-orange-500 border-t border-r border-b border-gray-200">
              <div className="text-sm font-semibold text-gray-700">Sans tag TC_by_IA</div>
              <div className="text-4xl font-bold text-orange-700 mt-2">{withoutTagTcByIa}</div>
              <div className="text-sm text-gray-600 mt-1">{withoutTagPercent}% du total</div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
            <h3 className="text-sm font-semibold text-gray-700 mb-3">Evolution des TA d'API</h3>
            <div className="flex items-center justify-between">
              <div>
                <div className="text-xs text-gray-500">Début 2025</div>
                <div className="text-2xl font-bold text-blue-700">150</div>
                <div className="text-xs text-gray-500">Test auto</div>
              </div>
              <div className="text-gray-500 text-2xl">→</div>
              <div>
                <div className="text-xs text-gray-500">Aujourd'hui</div>
                <div className="text-2xl font-bold text-green-700">376</div>
                <div className="text-xs text-gray-500">Test auto</div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
            <h3 className="text-sm font-semibold text-gray-700 mb-3">Evolution des TA de browser</h3>
            <div className="flex items-center justify-between">
              <div>
                <div className="text-xs text-gray-500">Début 2025</div>
                <div className="text-2xl font-bold text-blue-700">0</div>
                <div className="text-xs text-gray-500">Test auto</div>
              </div>
              <div className="text-gray-500 text-2xl">→</div>
              <div>
                <div className="text-xs text-gray-500">Aujourd'hui</div>
                <div className="text-2xl font-bold text-green-700">75</div>
                <div className="text-xs text-gray-500">Test auto</div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
            <h3 className="text-sm font-semibold text-gray-700 mb-3">Evolution des Test Unitaires Back</h3>
            <div className="flex items-center justify-between">
              <div>
                <div className="text-xs text-gray-500">Début 2025</div>
                <div className="text-2xl font-bold text-blue-700">620</div>
                <div className="text-xs text-gray-500">Test auto</div>
              </div>
              <div className="text-gray-500 text-2xl">→</div>
              <div>
                <div className="text-xs text-gray-500">Aujourd'hui</div>
                <div className="text-2xl font-bold text-green-700">2918</div>
                <div className="text-xs text-gray-500">Test auto</div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
            <h3 className="text-sm font-semibold text-gray-700 mb-3">Evolution des Test Unitaires front</h3>
            <div className="flex items-center justify-between">
              <div>
                <div className="text-xs text-gray-500">Début 2025</div>
                <div className="text-2xl font-bold text-blue-700">1128</div>
                <div className="text-xs text-gray-500">Test auto</div>
              </div>
              <div className="text-gray-500 text-2xl">→</div>
              <div>
                <div className="text-xs text-gray-500">Aujourd'hui</div>
                <div className="text-2xl font-bold text-green-700">3849</div>
                <div className="text-xs text-gray-500">Test auto</div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4">
          <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
            <h3 className="text-sm font-semibold text-gray-700 mb-3">Evolution des tests d'exploitation</h3>
            <div className="flex items-center justify-between">
              <div>
                <div className="text-xs text-gray-500">Début 2025</div>
                <div className="text-2xl font-bold text-blue-700">0</div>
                <div className="text-xs text-gray-500">Test auto</div>
              </div>
              <div className="text-gray-500 text-2xl">→</div>
              <div>
                <div className="text-xs text-gray-500">Aujourd'hui</div>
                <div className="text-2xl font-bold text-green-700">38</div>
                <div className="text-xs text-gray-500">Test auto</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
